import React from 'react'
import PropTypes from 'prop-types'

import fonts from '~/utils/fonts'
import colors from '~/utils/colors'

import { Content } from './styles'

function H1(props) {
  return <Content {...props} />
}

H1.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  font: PropTypes.string,
  color: PropTypes.string,
}

H1.defaultProps = {
  fonts: fonts.displayRegular,
  color: colors.dark,
}

export default H1
